import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "core-js/modules/es6.regexp.split";
import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
export default {
  name: "SelectLocalLoad",
  components: {},
  props: {
    isCollapseTags: {
      type: Boolean,
      default: false
    },
    isObjType: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 2
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array | String,
      default: ""
    },
    labelTitle: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    filterCallBack: {
      type: Function,
      default: function _default() {}
    },
    // 在非接口请求时使用的数据
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 搜索扩展入参
    selectParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isParamsOut: {
      type: Boolean,
      default: false
    },
    /**
     * @propsValue 下拉框中的value的键
     * @propsLabel 下拉框中的label的键
     */
    propsValue: {
      type: String,
      default: function _default() {
        return "value";
      }
    },
    propsLabel: {
      type: String,
      default: function _default() {
        return "label";
      }
    },
    /**
     * @param dataSource
     * false: 默认以传入data进行下拉框操作
     * true: 通过函数获取data数据进行下拉框操作
     */
    dataSource: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    pageSize: {
      type: Number | String,
      default: function _default() {
        return 20;
      }
    },
    // 返回的数据结构
    resultStructure: {
      type: String,
      default: function _default() {
        return "data.rows";
      }
    },
    // 查询字段名称
    searchName: {
      type: String,
      default: function _default() {
        return "name";
      }
    },
    editorSatatus: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isFirstShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    otherParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectEle: "",
      list: [],
      dataListFilter: [],
      scrollIndex: 1,
      loading: false,
      SELECTWRAP_DOM: null,
      search_name: "",
      dataFilterFlag: false,
      // 控制接口请求
      endLoading: false,
      timer: null,
      hideByClear: false,
      visibleChangeStatus: false
    };
  },
  watch: {
    selectParams: {
      handler: function handler(v, o) {
        var _this = this;
        if (this.dataSource && !this.isFirstShow && this.isParamsOut) {
          this.list.splice(0);
          this.scrollIndex = 1;
          this.getData();
          this.$nextTick(function () {
            _this.scrollIndex++;
          });
        }
      },
      deep: true,
      immediate: true
    },
    dataList: {
      handler: function handler(v, o) {
        if (this.dataSource) return;
        this.getTruckNoList();
      },
      deep: true,
      immediate: true
    },
    selectList: {
      handler: function handler(v, o) {
        var _this2 = this;
        /**
         * if (!v || (v && v.length === 0)) {
         * this.selectEle = null;
         * this.scrollIndex = 1;
         *  this.list.splice(0, this.list.length);
         *  this.getData();
         *  } else
         */
        if (this.editorSatatus && this.isObjType && this.isFirstShow && v) {
          // 处理编辑时的数据预处理
          console.log(v);
          var list = [];
          this.scrollIndex = 1;
          this.$emit("update:isFirstShow", false);
          this.list.splice(0);
          if (Array.isArray(v)) {
            if (v.length) {
              this.list = JSON.parse(JSON.stringify(v));
              this.$nextTick(function () {
                _this2.selectEle = JSON.parse(JSON.stringify(v));
              });
            } else {
              this.resetSlectData();
            }
          } else {
            if (v) {
              this.selectEle = JSON.parse(JSON.stringify(v));
              this.list.push(v);
            } else {
              this.resetSlectData();
            }
          }
          this.$nextTick(function () {
            _this2.scrollIndex++;
          });
          /**
           * value 内 存储着当前需要展示的数据
           *  this.list 存放回显下拉框中的数据
           *  this.selectEle 存放目前已选择的条目
           * */
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    this.SELECTWRAP_DOM = this.$refs.ykSelectlazyload.$el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
    this.SELECTWRAP_DOM.addEventListener("scroll", this.infinityload);
    if (this.dataSource && !this.isFirstShow && !this.isParamsOut) {
      // if (this.dataSource) {
      this.resetSlectData();
    }
  },
  created: function created() {},
  destroyed: function destroyed() {
    this.SELECTWRAP_DOM.removeEventListener("scroll", this.infinityload);
  },
  methods: {
    getEditorData: function getEditorData(list) {
      return Promise.all(list);
    },
    clearChoose: function clearChoose() {
      this.selectEle = null;
      this.search_name = "";
    },
    resetSlectData: function resetSlectData() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.list.splice(0);
        _this3.selectEle = null;
        _this3.scrollIndex = 1;
        _this3.getData();
      });
    },
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this4 = this;
        var params, info, pages, resultStructure, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log("search_name", this.search_name);
              // if (!this.search_name) return;
              params = {
                pageSize: this.pageSize,
                pageNum: this.scrollIndex
              };
              params[this.searchName] = this.search_name;
              params = _objectSpread(_objectSpread(_objectSpread({}, this.otherParams), params), this.selectParams);
              this.loading = true;
              _context.n = 1;
              return this.filterCallBack(this.$filterObj(params));
            case 1:
              info = _context.v;
              this.dataFilterFlag = false;
              this.loading = false;
              try {
                if (info && info.code === 200) {
                  pages = info.data.pages || info.data.data.pages || 1;
                  if (+pages <= this.scrollIndex) {
                    this.endLoading = true;
                  } else {
                    this.endLoading = false;
                  }
                  resultStructure = this.resultStructure.split(".");
                  data = this.getResultStructure(info, resultStructure);
                  data = data ? data : [];
                  // 单独处理 返回的字符串数据
                  data = data.map(function (item) {
                    var obj = item;
                    if (typeof item === "string") {
                      obj = {
                        label: item,
                        value: item
                      };
                    }
                    return obj;
                  });
                  this.list = this.list.concat(data);
                  this.$nextTick(function () {
                    _this4.scrollIndex++;
                  });
                }
              } catch (e) {
                console.log(e);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    getResultStructure: function getResultStructure(data, list) {
      var key = list.shift();
      var d = data[key];
      if (list.length) {
        d = this.getResultStructure(d, list);
      }
      return d;
    },
    infinityload: function infinityload() {
      var _this5 = this;
      var CONDITION = this.SELECTWRAP_DOM.scrollHeight - this.SELECTWRAP_DOM.scrollTop <= this.SELECTWRAP_DOM.clientHeight + 5;
      if (CONDITION) {
        console.log("===scrollIndex==infinityload====>" + this.dataSource, this.dataFilterFlag);
        if (this.dataSource) {
          if (this.dataFilterFlag || this.endLoading) return;
          this.dataFilterFlag = true;
          setTimeout(function () {
            _this5.getData();
          }, 500);
        } else {
          this.load();
        }
      }
    },
    load: function load() {
      var _this6 = this;
      this.list = this.dataListFilter.filter(function (item, index) {
        return index < (_this6.scrollIndex + 1) * 20;
      });
      this.$nextTick(function () {
        _this6.scrollIndex++;
      });
    },
    getTruckNoList: function getTruckNoList() {
      var _this$list,
        _this7 = this;
      this.dataListFilter = _toConsumableArray(this.dataList);
      var data = this.dataList.filter(function (item, index) {
        return index < 20;
      });
      (_this$list = this.list).push.apply(_this$list, _toConsumableArray(data));
      this.$nextTick(function () {
        _this7.scrollIndex++;
      });
    },
    filtermethod: function filtermethod(v) {
      var _this8 = this;
      console.log("filtermethod", v);
      this.scrollIndex = 1;
      clearTimeout(this.timer);
      if (this.dataSource) {
        if (!v || v.length >= this.maxLength) {
          this.dataFilterFlag = true;
          // 500毫秒后开始查询
          this.timer = setTimeout(function () {
            _this8.dataFilter_02(v);
          }, 500);
        }
      } else {
        this.dataFilter_01(v);
      }
    },
    dataFilter_01: function dataFilter_01() {
      var _this9 = this;
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.list.splice(0);
      this.$nextTick(function () {
        var _this9$list;
        _this9.dataListFilter = _this9.dataList.filter(function (item) {
          return item[_this9.propsLabel].indexOf(v) !== -1;
        });
        var data = _this9.dataListFilter.filter(function (item, index) {
          return index < 20;
        });
        (_this9$list = _this9.list).push.apply(_this9$list, _toConsumableArray(data));
        _this9.$nextTick(function () {
          _this9.SELECTWRAP_DOM.scrollTop = 0;
        });
      });
    },
    dataFilter_02: function dataFilter_02() {
      var _this0 = this;
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.list.splice(0);
      this.search_name = v.trim();
      this.$nextTick(function () {
        _this0.getData();
      });
    },
    change: function change(v) {
      if (!v || v && v.length === 0) {
        this.scrollIndex = 1;
        if (this.dataSource) {
          this.dataFilter_02();
        } else {
          this.dataFilter_01();
        }
      }
      this.parentEmit(v);
    },
    clearSelector: function clearSelector() {
      // this.scrollIndex = 1;
      // // if (this.visibleChangeStatus) {
      // //   this.hideByClear = true;
      // // }
      // if (this.dataSource) {
      //   this.dataFilter_02();
      // } else {
      //   this.dataFilter_01();
      // }
      this.parentEmit();
    },
    visibleChangeSelector: function visibleChangeSelector(flag) {
      // console.log("visibleChangeSelector", flag);
      // this.visibleChangeStatus = flag;
      // if (!flag) {
      //   if (this.list.length === 0) {
      //     this.selectEle = null;
      //   }
      //   if (this.hideByClear) {
      //     this.hideByClear = false;
      //   } else {
      //     if (!this.selectEle && this.selectEle !== 0) {
      //       this.list.splice(0)
      //       this.scrollIndex = 1;
      //       if (this.dataSource) {
      //         this.dataFilter_02();
      //       } else {
      //         this.dataFilter_01();
      //       }
      //       console.log("visibleChangeSelector", this.selectEle);
      //       this.parentEmit();
      //     }
      //   }
      // }
    },
    parentEmit: function parentEmit() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.$emit("update:selectList", v);
      this.$emit("change", v);
    }
  }
};